import "../Styles/Menu.css";

import bckg from "../Images/order.svg";
import Navbar from "../Components/Navbar";
import { useTranslation } from "react-i18next";
import icn1 from "../Images/customerProfile.svg";
import icn2 from "../Images/orderDetailsIconActive.svg";
import icn3 from "../Images/menuIconActive.svg";
import icn4 from "../Images/basketIconUnactive.svg";
import {
  RiArrowRightSFill,
  RiArrowLeftSFill,
  RiShoppingCartFill,
  RiDeleteBin6Line,
} from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import AddToCart from "../Components/AddToCart";
import { ImInfo } from "react-icons/im";
import category from "../Images/category.png";
import { useEffect, useState, useRef } from "react";
import { BeatLoader } from "react-spinners";
import {
  payment_methods,
  categories,
  products,
  product,
  Get_Basket,
  Delete_Item,
  Clear_cart,
  Edit_Quantity,
  check_offer,
  create_order,
  cancel_direct,
  accept_order,
  awafiBalance,
  getPaymentMethod

} from "../api";

import ErrorModal from "../Components/ErrorModal";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import RemoveItem from "../Components/RemoveItem";
import CleartCart from "../Components/CleartCart";
import FreeMeals from "../Components/FreeMeals";
import CashBack from "../Components/CashBack";
import { customerAddresses } from "../api";
import { AiOutlineSearch } from "react-icons/ai";
import { TiTick, TiArrowRight } from "react-icons/ti";
import { MdArrowForwardIos } from "react-icons/md";
import Discount from "../Components/Discount";
import { search } from "../api";

function Menu(props) {
  var touchsupport =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  const [modal, setModal] = useState(false);
  const [toggleCart, setToggleCart] = useState(false);

  const { t, i18n } = useTranslation();
  let history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [freeMealsModal, setFreeMealsModal] = useState(false);
  const [freeMeals, setFreeMeals] = useState([]);
  const [menuLoading, setMenuLoading] = useState(false);
  //const[paymentMethod,setPaymentMethod]=useState((localStorage.getItem("editPaymentMethod"))?localStorage.getItem("editPaymentMethod"):"cash")
  const [arMsg, setArMsg] = useState();
  const [cashBack, setCashBack] = useState(false);
  const [enMsg, setEnMsg] = useState();
  const [removeModal, setRemoveModal] = useState(false);
  const [clearModal, setClearModal] = useState(false);
  const [errModal, setErrModal] = useState(false);
  const [errModal2, setErrModal2] = useState(false);
  const [mealId, setMealId] = useState();
  const [freeMealsDisc, setFreeMealsDisc] = useState(false);
  const [cashBackDisc, setCashBackDisc] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [delSizeId, setDelSizedId] = useState();
  const [delAddId, setDelAddId] = useState();
  const [quantity, setQuantity] = useState();

  const [menuCategories, setMenuCategories] = useState([]);
  const [productList, setProductList] = useState([]);
  const [notesSearch, setNotesSearch] = useState("");
  const [noNotes, setNoNotes] = useState(false);
  const [quanLoading, setQuanLoading] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [productData, setProductData] = useState();
  const [basket, setBasket] = useState(null);
  const [searchTerm, SetSearchTerm] = useState("");
  const [add, setAdd] = useState(false);
  const [discount, setDiscount] = useState(false);
  const [discAmount, setDiscAmount] = useState();
  const [discTotal, setDiscTotal] = useState();
  const [delId, setDelId] = useState();
  const [noProduct, setNoProduct] = useState(false);
  const [payment, setPayment] = useState();
  const [laterPeriod, setLaterPeriod] = useState(false);


  const [paymentData, setPaymentData] = useState(null);


  const [note, setNote] = useState("");

  const [noteText, setNoteText] = useState(
    localStorage.getItem("notes")
      ? localStorage.getItem("notes")
      : localStorage.getItem("editNotes")
        ? localStorage.getItem("editNotes")
        : ""
  );
  const [address, setAddress] = useState({
    arAddress: "",
    enAddress: "",
  });

  const [tableDiscountType, setTableDiscountType] = useState(
    localStorage.getItem("tableDiscountType")
      ? localStorage.getItem("tableDiscountType")
      : ""
  );
  const [selectedPayment, setSelectedPayment] = useState(
    localStorage.getItem("selectedPayment") || ""
  );
  const [selectedOnlineType, setSelectedOnlineType] = useState(
    localStorage.getItem("selectedOnlineType") || ""
  );




  let phoneRegEx =
    /^(05)[0-9]{8}$|^(03)[0-9]{8}$|^(3)[0-9]{7}$|^(6)[0-9]{7}$|^(7)[0-9]{7}$/;



  const [submitLoading, setSubmitLoading] = useState(false);
  const [cartChange, setCartChange] = useState(false);
  const [codeInvalid, setCodeInvalid] = useState(false);
  const [branchId, setBranchId] = useState(
    parseInt(localStorage.getItem("branchId"))
  );
  //const [notes,setNotes]= useState(localStorage.getItem("editNotes")?localStorage.getItem("editNotes"):" ")

  const codeRef = useRef();
  const [codeValue, setCodeValue] = useState(
    localStorage.getItem("promoCode") ? localStorage.getItem("promoCode") : null
  );
  const [disableButton, setDisableButton] = useState(true);
  const [walletLoad, setWalletLoad] = useState(true);
  const [showButton, setShowButton] = useState(false);

  var today = new Date();
  let month = today.getMonth() + 1;
  let year = today.getFullYear();
  let day = today.getDate();
  let hour = today.getHours();
  let minute = today.getMinutes();
  let second = today.getSeconds();


  var checkList;
  function dropDown() {
    checkList = document.getElementById("list1");
    if (checkList.classList.contains("visible")) {
      checkList.classList.remove("visible");
    } else {
      checkList.classList.add("visible");
    }

    if (localStorage.getItem("notesCheckbox")) {
      console.log("test");
      var arr = localStorage.getItem("notesCheckbox").split(",");
      var elements = document.getElementsByClassName("checkNotes");
      for (var i = 0; i < elements.length; i++) {
        for (var j = 0; j < elements.length; j++) {
          if (elements[i].value == arr[j]) {
            elements[i].checked = true;
          }
        }
      }
    }

    var checkArr = [];
    var check = document.getElementsByClassName("checkNotes");
    for (var i = 0; i < check.length; i++) {
      if (check[i].checked) {
        checkArr.push(" " + check[i].value);
      }
    }
    const notes = checkArr.toString();
    setNote(notes);
  }


  function handleChangeQuantityOffline(
    mealId,
    sizeId,
    additionals,
    quantity,
    oldQuantity
  ) {
    setQuanLoading(true);

    if (quantity < 1) {
      // Update the state with the old quantity
      setQuantity(oldQuantity);
    } else {
      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      const updatedCartItems = cartItems.map((item) => {
        if (additionals == null || additionals == []) {
          if (item.id === mealId && item.sizeId == sizeId) {
            return { ...item, quantity };
          }
          return item;
        } else {
          if (
            item.id === mealId &&
            item.sizeId == sizeId &&
            item.additionals == additionals
          ) {
            return { ...item, quantity };
          }
          return item;
        }
      });

      localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
      setCartChange(!cartChange); // Called to rerender useEffect
      setQuantity(quantity); // Update the state with the new quantity
    }

    setQuanLoading(false);
  }

  useEffect(() => {
    if (selectedPayment && paymentData) {
      localStorage.setItem("selectedPayment", selectedPayment);
      localStorage.setItem("selectedOnlineType", paymentData.paymentMethods.paymentOnlineType);

    }

    if (selectedPayment == 'cash' || selectedPayment == 'wallet') {
      localStorage.removeItem("selectedOnlineType")
      localStorage.removeItem("PaymentMethodDisc")
    }

  }, [selectedPayment, selectedOnlineType]);



  function handleNotes(e) {
    var checkArr = [];
    var check = document.getElementsByClassName("checkNotes");
    for (var i = 0; i < check.length; i++) {
      if (check[i].checked) {
        checkArr.push("" + check[i].value);
      }
    }
    const notes = checkArr.toString();
    setNote(notes);
    localStorage.setItem("notesCheckbox", notes);

    if (localStorage.getItem("editNotes")) {
      localStorage.setItem("editNotes", notes);
    }
  }

  //if order type id is 2 (home delivery) customerAddresses api is called takes token and customer id to retrive customer addressses
  //address is set to the address with matching id (chosen in order details step)
  //Get_Basket api call takes token and customer id()=> fetch customer cart data
  //payment_methods api call takes token, cart id and delivery type (oridnary if order type id is 2 else " ")()=> fetch customer cart data and payment options
  //categories api call takes token ()=>fetch categories
  //getProducts function is called with inital category id as argument ()=> fetch products

  // useEffect(() => {
  //   awafiBalance(
  //     localStorage.getItem("token"),
  //     localStorage.getItem("customerPhone")
  //   )
  //     .then((res) => {
  //       localStorage.setItem(
  //         "userAwaifiBalance",
  //         res.data.data.expirableWalletBalance
  //       );
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });


  // }, []);

  const static_notes = [
    "احضار شبكة",
    "بدون مخلل",
    "بدون ثوم",
    "بدون بطاطس",
    "زيادة ثوم",
    "زيادة مخلل",
    "زيادة بطاطس",
    "سادة مع بطاطس فقط",
    "إضافة جبن",
    "بدون بقدونس بدون سلطة"
  ];

  const static_notes_en = [
    "Bring a network (tray)",
    "No pickles",
    "No garlic",
    "No potatoes",
    "Extra garlic",
    "Extra pickles",
    "Extra potatoes",
    "Plain with potatoes only",
    "Add cheese",
    "No parsley, no salad"
  ];



  const getPaymentMethods = () => {
    const token = localStorage.getItem("token");

    const data = {
      sourceId: localStorage.getItem("orderSource"),
      platform: "agent",
      price: calculateTotalPrice(true) || 0,
      addressId: localStorage.getItem("addressId"),
      typeId: localStorage.getItem("orderType"),
      branchId: localStorage.getItem("branchId"),
      userId: localStorage.getItem("customerId"),
    };

    getPaymentMethod(token, data)
      .then((res) => {
        if (res?.data?.data) {
          const response = res.data.data;

          // store everything in state for use in UI
          setPaymentData({
            deliveryPrice: response.deliveryPrice,
            originalPrice: response.originalPrice,
            paymentAccounts: response.paymentAccounts,
            paymentMethods: response.paymentMethods,
            tax: response.tax,
            taxValue: response.taxValue,
            totalPrice: response.totalPrice,
            walletBalance: response.walletBalance,
            areaData: response.areaData

          });
        }
      })
      .catch((err) => {
        console.error("Error fetching payment methods:", err);
      });
  };




  useEffect(() => { getPaymentMethods() }, [localStorage.getItem("cartItems")])




  useEffect(() => {



    const token = localStorage.getItem("token");




    if (parseInt(localStorage.getItem("orderType")) === 2) {
      customerAddresses(token, localStorage.getItem("customerId"))
        .then((response) => {
          const found = response.data.data.find(
            (element) =>
              element.id == parseInt(localStorage.getItem("addressId"))
          );
          if (found) {
            setAddress({
              arAddress: found.arAddress,
              enAddress: found.enAddress,
            });
          }
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            history("/");
          }
        });
    }

    /*
  if(parseInt(localStorage.getItem("orderSource")) === 40 || parseInt(localStorage.getItem("orderSource")) === 80 || parseInt(localStorage.getItem("orderSource")) === 85 || parseInt(localStorage.getItem("orderSource")) === 95){
    localStorage.setItem("paymentMethod","paid");
   // setPaymentMethod("paid")
   
}else if(!localStorage.getItem("paymentMethod")){
    localStorage.setItem("paymentMethod","cash");
}*/

    categories(token, parseInt(localStorage.getItem("orderType")))
      .then((response) => {
        setMenuCategories(response.data.data);

        if (categoryId == null) {
          setCategoryId(response.data.data[0].id);
          getProducts(response.data.data[0].id);
        } else {
          getProducts(categoryId);
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          history("/");
        }

        setArMsg(error.response.data.error);
        setEnMsg(error.response.data.error);
        setErrModal(true);

        setLoading(false);
        setTimeout(function () {
          setErrModal(false);
        }, 2500);
      });
  }, []);

  useEffect(() => {
    SetSearchTerm("");
    setNoProduct(false);

    const token = localStorage.getItem("token");


  }, [add, cartChange]);



  //function to check period
  function getPeriod(ff, ft, sf, st) {
    var firstPeriodTimeFrom = ff;
    var firstPeriodTimeTo = ft;
    var secondPeriodTimeFrom = sf;
    var secondPeriodTimeTo = st;

    var now = new Date(year, month, day, hour, minute, second);
    var firstOnept1 = new Date(
      year,
      month,
      day,
      firstPeriodTimeFrom.slice(0, 2),
      firstPeriodTimeFrom.slice(3, 5),
      firstPeriodTimeFrom.slice(6, 8)
    );
    var firstOnept2 = new Date(
      year,
      month,
      day,
      firstPeriodTimeTo.slice(0, 2),
      firstPeriodTimeTo.slice(3, 5),
      firstPeriodTimeTo.slice(6, 8)
    );
    var secondOnept1 = new Date(
      year,
      month,
      day,
      secondPeriodTimeFrom.slice(0, 2),
      secondPeriodTimeFrom.slice(3, 5),
      secondPeriodTimeFrom.slice(6, 8)
    );
    var secondOnept2 = new Date(
      year,
      month,
      day,
      secondPeriodTimeTo.slice(0, 2),
      secondPeriodTimeTo.slice(3, 5),
      secondPeriodTimeTo.slice(6, 8)
    );

    if (localStorage.getItem("now") == "false") {
      const date = localStorage.getItem("orderDate");
      const time = localStorage.getItem("orderTime");

      const laterDate = new Date(
        date.slice(0, 4),
        date.slice(5, 7),
        date.slice(8, 10),
        time.slice(0, 2),
        time.slice(3, 5),
        time.slice(6, 8)
      );

      if (firstOnept1 <= now && now <= firstOnept2) {
        if (!(firstOnept1 <= laterDate && firstOnept2 >= laterDate)) {
          setDisableButton(false);
        } else {
          setDisableButton(true);
        }
      } else {
        console.log("second");
        if (!(secondOnept1 <= laterDate && secondOnept2 >= laterDate)) {
          setDisableButton(false);
        } else {
          setDisableButton(true);
        }
      }
    }
  }

  //called on changing category
  //set active category
  /*products api call takes token, chosen category id, branch id and order source code
fetch products,*/
  const getProducts = (categoryId) => {
    localStorage.setItem("categoryId", categoryId);

    const token = localStorage.getItem("token");

    products(token, categoryId, branchId, localStorage.getItem("orderSource"))
      .then((response) => {
        setCategoryId(categoryId);

        setProductList(response.data.data);
        setMenuLoading(false);

        // const period = response.data.period;

        // var firstPeriodTimeFrom = period.firstPeriodTimeFrom;
        // var firstPeriodTimeTo = period.firstPeriodTimeTo;
        // var secondPeriodTimeFrom = period.secondPeriodTimeFrom;
        // var secondPeriodTimeTo = period.secondPeriodTimeTo;

        // var now = new Date(year, month, day, hour, minute, second);
        // var firstOnept1 = new Date(
        //   year,
        //   month,
        //   day,
        //   firstPeriodTimeFrom.slice(0, 2),
        //   firstPeriodTimeFrom.slice(3, 5),
        //   firstPeriodTimeFrom.slice(6, 8)
        // );
        // var firstOnept2 = new Date(
        //   year,
        //   month,
        //   day,
        //   firstPeriodTimeTo.slice(0, 2),
        //   firstPeriodTimeTo.slice(3, 5),
        //   firstPeriodTimeTo.slice(6, 8)
        // );
        // var secondOnept1 = new Date(
        //   year,
        //   month,
        //   day,
        //   secondPeriodTimeFrom.slice(0, 2),
        //   secondPeriodTimeFrom.slice(3, 5),
        //   secondPeriodTimeFrom.slice(6, 8)
        // );
        // var secondOnept2 = new Date(
        //   year,
        //   month,
        //   day,
        //   secondPeriodTimeTo.slice(0, 2),
        //   secondPeriodTimeTo.slice(3, 5),
        //   secondPeriodTimeTo.slice(6, 8)
        // );

        // if (localStorage.getItem("now") == "false") {
        //   const date = localStorage.getItem("orderDate");
        //   const time = localStorage.getItem("orderTime");

        //   const laterDate = new Date(
        //     date.slice(0, 4),
        //     date.slice(5, 7),
        //     date.slice(8, 10),
        //     time.slice(0, 2),
        //     time.slice(3, 5),
        //     time.slice(6, 8)
        //   );

        //   if (firstOnept1 <= now && now <= firstOnept2) {
        //     if (!(firstOnept1 <= laterDate && firstOnept2 >= laterDate)) {
        //       setLaterPeriod(true);
        //     }
        //   }
        //    else {
        //     if (!(secondOnept1 <= laterDate && secondOnept2 >= laterDate)) {
        //       setLaterPeriod(true);
        //     }
        //   }
        // } else {
        //   setLaterPeriod(false);
        // }



        //(false)
      })
      .catch(function (error) {

        console.log(error)

        setArMsg(error.response.data.error);
        setEnMsg(error.response.data.error);
        setErrModal(true);

        setMenuLoading(false);
        setLoading(false);
        setTimeout(function () {
          setErrModal(false);
        }, 2500);
      });
  };
  //to presist category
  useEffect(() => {
    setCategoryId(localStorage.getItem("categoryId"));
  }, [add, cartChange]);

  //called on choosing product
  //product api call takes token, chosen product id, branch id and order source code ()=> fetch product data
  const getProduct = (productId) => {
    const token = localStorage.getItem("token");

    product(
      token,
      productId,
      branchId,
      localStorage.getItem("orderSource"),
      parseInt(localStorage.getItem("customerId"))
    )
      .then((response) => {
        setProductData(response.data.data);

        setModal(true);
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          history("/");
        } else {
          setArMsg(error.response.data.error);
          setEnMsg(error.response.data.error);
          setErrModal(true);

          setTimeout(function () {
            setErrModal(false);
          }, 2500);
        }
      });
  };

  //on confirming clear in ClearCart component
  //Clear_cart api call takes cart id and token

  // const getCustomerBalance = () => {
  //   const token = localStorage.getItem("token")
  //   awafiBalance(token, localStorage.getItem("customerPhone"))
  //     .then((res) => {
  //       localStorage.setItem(
  //         "userAwaifiBalance",
  //         res.data.data.expirableWalletBalance
  //       );
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  function handleClear() {
    setClearModal(false);


    // 🔹 Remove all items from localStorage cart
    localStorage.removeItem("cartItems");

    // 🔹 Reset all related stored values
    localStorage.removeItem("userAwaifiBalance");
    localStorage.removeItem("offer");
    localStorage.removeItem("notes");
    localStorage.removeItem("tableDiscount");
    localStorage.removeItem("tableDiscountType");
    localStorage.removeItem("tableAccount");
    localStorage.removeItem("PaymentMethodDisc");
    localStorage.removeItem("PaymentMethodDiscContd");
    localStorage.removeItem("promoCode");
    localStorage.removeItem("notesCheckbox");
    localStorage.removeItem("editNotes");
    localStorage.removeItem("cancelOrderId");
    localStorage.removeItem("editPaymentMethod");


    setDiscount(false);
    localStorage.setItem("discount", "false");
    setCodeValue("");
    setErrModal2(false);
    setCodeInvalid(false);
    localStorage.setItem("discount", "false");



    setNote("");
    setNoteText("");
    setCartChange(!cartChange); // trigger UI refresh
    setLoading(false);
  }
  //on confirming clear in RemoveItem component
  //Delete_Item api call takes cart id and meal id (set when clicking delete on a meal) token
  function handleRemove() {
    setRemoveModal(false);
    setLoading(true);


    let cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];


    console.log(cartItems)
    const updatedCart = cartItems.filter(item => {

      const sameProduct = item.productId === delId || item.id === delId;

      const sameSize = item.sized?.id === delSizeId || (!item.sized && !delSizeId);

      const sameAddition = item.selectedAddtionObj?.id === delAddId || (!item.selectedAddtionObj && !delAddId);


      // Keep the item unless it's the exact one being deleted
      return !(sameProduct && sameSize && sameAddition);
    });

    localStorage.setItem("cartItems", JSON.stringify(updatedCart));

    localStorage.removeItem("offer");
    localStorage.setItem("promoCode", codeValue);

    setCartChange(!cartChange);
    setLoading(false);
  }


  //onChanging meal quantity with buttons
  //Edit_Quantity api call takes cart id, meal id, new quantity and token
  function handleQuantity(mealId, quantity) {
    const token = window.localStorage.getItem("token");
    setQuanLoading(true);
    Edit_Quantity(localStorage.getItem("CartId"), mealId, quantity, token).then(
      (response) => {
        setCartChange(!cartChange); //called to rerender useEffect
      }
    );
  }

  //onChanging meal quantity
  //Edit_Quantity api call takes cart id, meal id, new quantity and token
  function handleChangeQuantity(
    mealId,
    quantity,
    oldQuantity,
    avalilableQuantity
  ) {
    setQuanLoading(true);
    const token = window.localStorage.getItem("token");
    setMealId(mealId);

    if (quantity < 1) {
      document.getElementById(`${mealId}`).value = oldQuantity;
      setQuanLoading(false);
    } else {
      if (quantity > avalilableQuantity && disableButton) {
        document.getElementById(`${mealId}`).value = avalilableQuantity;
        Edit_Quantity(
          localStorage.getItem("CartId"),
          mealId,
          avalilableQuantity,
          token
        ).then((response) => {
          localStorage.removeItem("offer");

          setCartChange(!cartChange); //called to rerender useEffect
        });
      } else {
        document.getElementById(`${mealId}`).value = quantity;

        Edit_Quantity(
          localStorage.getItem("CartId"),
          mealId,
          quantity,
          token
        ).then((response) => {
          localStorage.removeItem("offer");

          setCartChange(!cartChange); //called to rerender useEffect
        });
      }
    }
  }

  //check_offer api call takes (data) object
  //if there is a discount or free meals a modal is displayed
  function handleOffer(create) {
    console.log(create);

    if (create == true) {
      setShowButton(true);
      setSubmitLoading(true);
    } else {
      setShowButton(false);
    }
    setErrModal2(false);
    setCodeInvalid(false);


    if (selectedPayment == null || selectedPayment == "") {

      setErrModal(true);
      setArMsg("اختر طريقة الدفع");
      setEnMsg("Choose payment method");
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
      setSubmitLoading(false);
    } else if ((codeValue == null || codeValue == "") && create == false) {
      console.log(create);

      setDiscount(false);
      setFreeMealsDisc(false);
      setCashBackDisc(false);
      localStorage.setItem("discount", "false");
      setErrModal2(true);
      setArMsg(" برجاء إدخال الرمز الترويجي  ");
      setEnMsg("please enter promo code");
      setSubmitLoading(false);

    } else {
      const token = window.localStorage.getItem("token");

      var arr = [];
      var elements = document.getElementsByClassName("checkNotes");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].checked) {
          arr.push(elements[i].value);
        }
      }

      arr.push(noteText);
      const notes = arr.toString();
      const promoCode = localStorage.getItem("promoCode");
      const discountCode = !discount ? codeRef.current?.value : promoCode;
      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      const formattedProducts = cartItems.map(item => ({
        id: item.id,
        quantity: item.quantity,
        price: item.price,
        sizeId: item.sizeId,
        additionals: item.additionals || [],
        extras: item.extras || [],
      }));


      const data = {
        deliveryType: "normal",
        ...(localStorage.getItem("addressId") && {
          addressId: localStorage.getItem("addressId")
        }),
        platform: "agent",
        branchId: localStorage.getItem("branchId"),
        typeId: localStorage.getItem("orderType"),
        products: formattedProducts,
        notes: notes,
        date:
          localStorage.getItem("now") == "true"
            ? ""
            : localStorage.getItem("orderDate"),
        now: localStorage.getItem("now"),
        time:
          localStorage.getItem("now") == "true"
            ? ""
            : localStorage.getItem("orderTime"),
        paymentMethod: localStorage.getItem("selectedOnlineType") ? localStorage.getItem("selectedOnlineType") : selectedPayment,
        applicationId: 4,
        code: discountCode ? discountCode : "",
        userId:
          localStorage.getItem("customerId") != null
            ? parseInt(localStorage.getItem("customerId"))
            : parseInt(localStorage.getItem("userId")),
        accountType: localStorage.getItem("type"),
      };

      check_offer(data, token, localStorage.getItem("orderSource"))
        .then((response) => {
          setCodeInvalid(false);
          getPaymentMethods()

          if (response.data.data.offerType === "freeMeals") {
            localStorage.setItem("offer", true);
            setFreeMeals(response.data.data.freeMeals);
            setFreeMealsModal(true);
            setFreeMealsDisc(true);
          } else if (response.data.data.offerType === "discount") {
            localStorage.setItem("offer", true);
            setDiscount(true);
            if (create == true) {
              setDiscountModal(true);
            }
            setDiscAmount(response.data.data.discount);
            setDiscTotal(response.data.data.totalPrice);
            localStorage.setItem("discount", "true");


          } else if (response.data.data.offerType === "cashBack") {
            localStorage.setItem("offer", true);
            setCashBack(true);
            setCashBackDisc(true);
          } else {
            setDiscount(false);
            setFreeMealsDisc(false);
            setCashBackDisc(false);
            localStorage.removeItem("offer");
            localStorage.setItem("discount", "false");
            setErrModal2(true);
            setArMsg("الرمز الترويجي غير صحيح");
            setEnMsg("Promo code is invalid");
            setSubmitLoading(false);

            if (create == true) {
              createOrder();
            }
          }
        })
        .catch((error) => {
          setDiscount(false);
          setFreeMealsDisc(false);
          setCashBackDisc(false);
          localStorage.setItem("discount", "false");

          if (error.response.status === 401) {
            history("/");
          } else if (error.response.data.errorType == "code") {

            setCodeInvalid(true);

            if (
              error.response.data.error ===
              "طلبك غير مستوفي لشروط الرمز الترويجي"
            ) {
              setEnMsg("طلبك غير مستوفي لشروط الرمز الترويجي");
              setArMsg("طلبك غير مستوفي لشروط الرمز الترويجي");
              setErrModal2(true);
              setSubmitLoading(false);
            } else if (
              error.response.data.error === "الرمز الترويجي غير صحيح"
            ) {
              setArMsg("الرمز الترويجي غير صحيح");
              setEnMsg("Promo code is invalid");
              setErrModal2(true);
              setSubmitLoading(false);
            } else if (
              error.response.data.error ===
              "الرمز الترويجي غير متاح في هذا الفرع"
            ) {
              setArMsg("الرمز الترويجي غير متاح في هذا الفرع");
              setEnMsg("Promo code is unavailable in this branch");
              setErrModal2(true);
              setSubmitLoading(false);
            }
          } else {

            getError(error.response.data.error);
          }
        });
    }
  }

  //on submitting order
  //create_order api call takes (data) object and token
  //user is then redirected to /order-success
  const createOrder = async (offerData = {}) => {
    const { applyOffer, applyOfferOtp } = offerData;
    const boolRemainder =
      ((localStorage.getItem("editPaymentMethod") &&
        localStorage.getItem("editPaymentMethod") == "wallet") ||
        (localStorage.getItem("PaymentMethodDisc") &&
          localStorage.getItem("PaymentMethodDisc") == "wallet") ||
        selectedPayment == "wallet") &&
      (discount
        ? !(paymentData.walletBalance >= discTotal)
        : !(paymentData.walletBalance >= paymentData.totalPrice));

    if (selectedPayment == null) {
      showError("اختر طريقة الدفع", "Choose payment method");
    } else if (
      boolRemainder

    ) {
      showError(
        "اختر طريقة استكمال الدفع",
        "Choose method to continue payment"
      );
    } else if (
      localStorage.getItem("tableDiscount") &&
      localStorage.getItem("tableDiscount") !== "" &&
      (localStorage.getItem("tableDiscountType") == null ||
        localStorage.getItem("tableDiscountType") == "")
    ) {
      showError("اختر نوع الخصم", "Choose discount type");
    } else if (
      localStorage.getItem("tableDiscount") &&
      localStorage.getItem("tableDiscount") !== "" &&
      (localStorage.getItem("tableAccount") == null ||
        localStorage.getItem("tableAccount") == "")
    ) {
      showError("اختر حساب الخصم", "Choose discount account");
    } else {
      const resReturened = await submitOrder(applyOffer, applyOfferOtp);
      console.log(resReturened)
      // Proceed with order creation
      return resReturened
    }
  };

  const showError = (arMsg, enMsg) => {
    setErrModal(true);
    setArMsg(arMsg);
    setEnMsg(enMsg);
    setTimeout(() => {
      setErrModal(false);
    }, 2000);
    setSubmitLoading(false);
  };

  const submitOrder = (applyOffer = false, applyOfferOtp = "") => {
    const token = window.localStorage.getItem("token");
    setSubmitLoading(true);
    const boolRemainder =
      ((localStorage.getItem("editPaymentMethod") &&
        localStorage.getItem("editPaymentMethod") == "wallet") ||
        (localStorage.getItem("PaymentMethodDisc") &&
          localStorage.getItem("PaymentMethodDisc") == "wallet") ||
        selectedPayment == "wallet") &&
      (discount
        ? !(paymentData.walletBalance >= discTotal)
        : !(paymentData.walletBalance >= paymentData.totalPrice));

    var arr = [];
    var elements = document.getElementsByClassName("checkNotes");
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].checked) {
        arr.push(elements[i].value);
      }
    }

    arr.push(noteText);
    const notes = arr.toString();
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
    const formattedProducts = cartItems.map(item => ({
      id: item.id,
      quantity: item.quantity,
      price: item.price,
      sizeId: item.sizeId,
      additionals: item.additionals || [],
      extras: item.extras || [],
    }));

    const data = {
      deliveryType: "normal",
      ...(localStorage.getItem("addressId") && {
        addressId: localStorage.getItem("addressId")
      }),
      branchId: localStorage.getItem("branchId"),
      typeId: localStorage.getItem("orderType"),
      products: formattedProducts,
      applyOffer: applyOffer,
      applyOfferOtp: applyOfferOtp,
      discountAccount: localStorage.getItem("tableDiscount")
        ? parseInt(localStorage.getItem("tableDiscount"))
        : "",
      discountType: localStorage.getItem("tableDiscountType")
        ? localStorage.getItem("tableDiscountType")
        : "",
      discountAmount: localStorage.getItem("tableAccount")
        ? parseInt(localStorage.getItem("tableAccount"))
        : "",
      paymentMethod: localStorage.getItem("selectedOnlineType") ? localStorage.getItem("selectedOnlineType") : selectedPayment,


      remainPaymentMethod:
        selectedPayment == "awafi" &&
          paymentData.totalPrice > parseFloat(localStorage.getItem("userAwaifiBalance"))
          ? paymentData.paymentMethods.paymentOnlineType
          : "",

      sourceId: parseInt(localStorage.getItem("orderSource")),
      externalOrderId:
        parseInt(localStorage.getItem("orderSource")) == 5
          ? ""
          : parseInt(localStorage.getItem("externalOrderId")),
      code:
        codeRef.current.value,
      notes: notes,
      applicationId: 4,
      canceledOrderId: localStorage.getItem("cancelOrderId")
        ? parseInt(localStorage.getItem("cancelOrderId"))
        : "",
      userId:
        localStorage.getItem("customerId") != null
          ? parseInt(localStorage.getItem("customerId"))
          : parseInt(localStorage.getItem("userId")),
      date:
        localStorage.getItem("now") == "true"
          ? ""
          : localStorage.getItem("orderDate"),
      now:
        localStorage.getItem("type") == "cashier"
          ? true
          : localStorage.getItem("now"),
      time:
        localStorage.getItem("now") == "true"
          ? ""
          : localStorage.getItem("orderTime"),
      tableId:
        parseInt(localStorage.getItem("orderType")) == 5
          ? parseInt(localStorage.getItem("selectedTable"))
          : "",
      userOrganizationId: JSON.parse(localStorage.getItem("accountType"))
        ? parseInt(localStorage.getItem("organizationId"))
        : null,
      accountType: localStorage.getItem("type"),
      platform: "agent",
    };
    console.log(data);

    return create_order(data, token)
      .then((response) => {
        const orderId = response.data.data.orderId;
        localStorage.setItem("orderId", orderId);

        handleOrderSuccess(response);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          history("/");
        } else if (error.response.status === 403) {
          showError(
            "لا توجد إذن لهذا الإجراء",
            "No permission for this action"
          );
        } else {

          getError(error.response.data.error);

        }
        throw error
      });
  };


  const handlePosResponse = (message, orderId) => {
    const rrnMatch = message.match(/<RRN>(.*?)<\/RRN>/);
    const rrn = rrnMatch ? rrnMatch[1] : null;
    const terminalMatch = message.match(/<TerminalID>(.*?)<\/TerminalID>/);
    const terminal = terminalMatch ? terminalMatch[1] : null;
    const cardSchemeMatch = message.match(/<CardScheme.*?English="(.*?)"/);
    const cardScheme = cardSchemeMatch ? cardSchemeMatch[1] : null;

    // Save CardScheme in local storage
    if (cardScheme) {
      localStorage.setItem("cardScheme", cardScheme);
    }

    if (rrn) {
      localStorage.setItem("rrn", rrn);
    }

    const transactionId = `${terminal}-${rrn}`;

    if (message.includes('<Result Arabic="مقبولة" English="APPROVED"/>')) {
      if (transactionId) {
        acceptOrder(orderId, transactionId, rrn);
      } else {
        showError(
          "لم يتم العثور على معرف المعاملة.",
          "Transaction ID not found."
        );
      }
    } else if (
      message.includes('<Result Arabic="مرفوضة" English="DECLINED"/>')
    ) {
      showError("تم رفض الدفع.", "Payment declined.");
    } else {
      const orderid = localStorage.getItem("orderId");
      showError(
        "فشل الدفع. حاول مرة أخرى.",
        "Payment failed. Please try again."
      );

      setTimeout(() => {
        history(`/my-order/${orderid}`);
      }, 2000);
    }
  };
  const calculateTotalPrice = (originalPrice = false) => {
    if (originalPrice == true) {

      const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");

      let total = 0;
      cartItems.forEach((item) => {
        total += item.price * item.quantity ;
      });



      return total

    }
    console.log(paymentData)


    // const currency =
    //   i18n.language === "ar"
    //     ? cartItems[0]?.arCurrency || ""
    //     : cartItems[0]?.enCurrency || "";

    return paymentData && paymentData.totalPrice

  };

  const calculateTotalPriceWithDiscount = () => {
    const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");

    let total = 0;
    cartItems.forEach((item) => {
      total += item.price * item.quantity;
    });

    const currency =
      i18n.language === "ar"
        ? cartItems[0]?.arCurrency || ""
        : cartItems[0]?.enCurrency || "";
    if (discount) {

      return total - discAmount
    } else {
      return total;
    }

  };



  const acceptOrder = (orderId, transactionId, rrn = "") => {
    const token = window.localStorage.getItem("token");

    const data = {
      transactionId: transactionId,
      cardType: localStorage.getItem("cardScheme"),
      platform: "agent",
      rrn: rrn
    };

    accept_order(data, token, orderId)
      .then((response) => {
        handleOrderSuccess(response);
        // localStorage.removeItem("customerId");
      })
      .catch((error) => {
        showError(
          "حدث خطأ في قبول الطلب. حاول مرة أخرى.",
          "Error accepting order. Please try again."
        );
        console.error("Error accepting order:", error);
      });
  };
  const calculateTaxValue = () => {
    const totalPrice = calculateTotalPrice();
    const tax = parseInt(localStorage.getItem("branchId")) == 32 ? 5 : 15;
    const taxV = tax / 100 + 1;

    const taxValue = parseFloat(((totalPrice / taxV) * tax) / 100).toFixed(2);
    return taxValue;
  };

  const handleOrderSuccess = (response) => {
    const token = window.localStorage.getItem("token");

    localStorage.removeItem("offer");
    localStorage.removeItem("orderDate");
    localStorage.removeItem("orderTime");
    localStorage.removeItem("tableNum");
    localStorage.removeItem("displayId");
    // localStorage.removeItem("orderType");
    localStorage.removeItem("now");
    localStorage.removeItem("orderSource");
    localStorage.removeItem("branchOrderTime");
    // localStorage.removeItem("customerId");
    localStorage.removeItem("customerPhone");

    if (localStorage.getItem("type") !== "cashier") {
      // localStorage.removeItem("branchId");
    }
    localStorage.removeItem("accountType");
    localStorage.removeItem("organizationId");
    localStorage.removeItem("orderDistrictId");
    // localStorage.removeItem("addressId");
    localStorage.removeItem("externalOrderId");

    localStorage.setItem("orderId", response.data.data.orderId);

    localStorage.removeItem("notes");
    localStorage.removeItem("tableDiscount");
    localStorage.removeItem("tableDiscountType");
    localStorage.removeItem("tableAccount");

    localStorage.removeItem("PaymentMethodDisc");
    localStorage.removeItem("promoCode");

    localStorage.removeItem("notesCheckbox");

    localStorage.setItem("discount", "false");
    localStorage.removeItem("PaymentMethodDiscContd");

    if (localStorage.getItem("cancelOrderId")) {
      cancel_direct(localStorage.getItem("cancelOrderId"), token)
        .then((response) => {
          localStorage.removeItem("editNotes");
          localStorage.removeItem("cancelOrderId");
          localStorage.removeItem("editPaymentMethod");
        })
        .catch((error) => {
          if (error.response.status === 401) {
            history("/");
          }
        });
    }

    history("/order-success");
  };

  //called in createOrder function and handleOffer function
  //handles errors
  function getError(msg) {
    if (msg === "branch not support branch pick up") {
      setErrModal(true);
      setEnMsg("branch not support branch pick up");
      setArMsg("الفرع لا يدعم خدمة توصيل الطالبات");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "branch not support delivery") {
      setErrModal(true);
      setArMsg("الفرع لا يدعم خدمة توصيل المنزل");
      setEnMsg("branch not support delivery");
      setSubmitLoading(false);

      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "empty_wallet") {
      setErrModal(true);
      setArMsg("نأسف ، انتهت صلاحية رصيد المحفظة برجاء اختيار طريقة دفع أخري ");
      setEnMsg(
        "Sorry , wallet credit is expired please select another payment method"
      );

      setSubmitLoading(false);
      setCartChange(!cartChange); //called to rerender useEffect

      setTimeout(function () {
        setErrModal(false);
      }, 3000);
    } else if (msg === "branch not exist") {
      setErrModal(true);
      setArMsg("الفرع خارج نطاق الخدمة");
      setEnMsg("branch not exist");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "branch not active") {
      setErrModal(true);
      setArMsg("الفرع غير متاح حاليا");
      setEnMsg("branch not active");
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
      setSubmitLoading(false);
    } else if (msg === "branch not open") {
      setErrModal(true);
      setArMsg("الفرع مغلق الأن");
      setEnMsg("branch not open");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "meal not exist") {
      setErrModal(true);
      setArMsg("الوجبة غير متاحة حاليا");
      setEnMsg("meal not exist");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "meal not active") {
      setErrModal(true);
      setArMsg("الوجبة غير متاحة حاليا");
      setEnMsg("meal not active");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "product not delivery") {
      setErrModal(true);
      setArMsg("الوجبة غير متاحة للتوصيل");
      setEnMsg("product not delivery");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "additional not delivery") {
      setErrModal(true);
      setArMsg("الإضافات غير متاحة للتوصيل");
      setEnMsg("additional not delivery");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "extra not exist") {
      setErrModal(true);
      setArMsg("الزيادات غير متاحة");
      setEnMsg("extra not exist");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "extra not belong to product") {
      setErrModal(true);
      setArMsg("الزيادات غير متوفرة مع الوجبة");
      setEnMsg("extra not belong to product");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "The selected code is invalid.1") {
      setErrModal(true);
      setArMsg("الكود غير صحيح");
      setEnMsg("The selected code is invalid.");

      document.getElementById("code").value = "";
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "address not valid") {
      setErrModal(true);
      setArMsg("العنوان غير صحيح");
      setEnMsg("address not valid");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "time not in branch time") {
      setErrModal(true);
      setArMsg("الفرع مغلق في الوقت المحدد");
      setEnMsg("time not in branch time");

      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "branch not support fast delivery") {
      setErrModal(true);
      setArMsg("الفرع لا يوفر التوصيل السريع");
      setEnMsg("branch not support fast delivery");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "branch busy") {
      setErrModal(true);
      setArMsg("الفرع مشغول، تقدر تطلب بعد الزحام.");
      setEnMsg(
        "This branch is currently busy. You can order for later when branch is not busy."
      );

      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "branch not support ordinary delivery") {
      setErrModal(true);
      setArMsg("الفرع لا يوفر التوصيل العادي");
      setEnMsg("branch not support ordinary delivery");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    } else if (msg === "The selected code is invalid.") {
      setErrModal(true);
      setArMsg("الكود غير صحيح");
      setEnMsg("The selected code is invalid");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    }
    else {


      setErrModal(true);
      setArMsg(msg);
      setEnMsg(msg);

      setSubmitLoading(false);
      setTimeout(function () {
        setErrModal(false);
      }, 2000);
    }
  }

  //on searching
  //checks if products exist matching search input value
  //if not (not products are available) is displayed  "setNoProduct(true)"
  function handleSearch(e) {
    SetSearchTerm(e.target.value);

    const products =
      productList &&
      productList.filter((data) => {
        if (e.target.value === "") {
          return data;
        } else if (
          data.enName.toLowerCase().includes(e.target.value.toLowerCase()) ||
          data.arName.toLowerCase().includes(e.target.value.toLowerCase()) ||
          data.arDescription
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          data.enDescription
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        ) {
          return data;
        }
      });
    if (products.length == 0) {
      setNoProduct(true);
    } else {
      setNoProduct(false);
    }
  }

  function handleSearchNotes(e) {
    setNotesSearch(e.target.value);

    const cartNotes =
      basket.cart.notes &&
      basket.cart.notes.filter((data) => {
        if (e.target.value === "") {
          return data;
        } else if (data.toLowerCase().includes(e.target.value.toLowerCase())) {
          return data;
        }
      });
    if (cartNotes.length == 0) {
      setNoNotes(true);
    } else {
      setNoNotes(false);
    }
  }


  function handleDelPromo() {
    setDiscount(false);
    setFreeMealsDisc(false);
    setCashBackDisc(false);
    localStorage.setItem("discount", "false");
    localStorage.removeItem("offer");

    setErrModal2(false);
    setCodeValue("");
    getPaymentMethods()
    setDiscAmount(null)

  }
  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch {
      return value; // return the raw value if it's not JSON
    }
  }
  const orderSourceObj = safeParse(localStorage.getItem("orderSourceObj"));
  const orderSource = safeParse(localStorage.getItem("orderSource"));
  const externalOrderId = safeParse(localStorage.getItem("externalOrderId"));

  return (
    <div className="bgCon">
      {modal ? (
        <AddToCart
          setErr={props.setErr}
          setMsg={props.setMsg}
          setStyle={props.setStyle}
          add={add}
          setLoading={setLoading}
          setAdd={setAdd}
          data={productData}
          setModal={setModal}
        />
      ) : null}
      {freeMealsModal ? (
        <FreeMeals
          setSubmitLoading={setSubmitLoading}
          createOrder={createOrder}
          button={showButton}
          setModal={setFreeMealsModal}
          freeMeals={freeMeals}
        />
      ) : null}
      {cashBack ? (
        <CashBack
          setSubmitLoading={setSubmitLoading}
          createOrder={createOrder}
          button={showButton}
          setModal={setCashBack}

        />
      ) : null}
      { }
      {discountModal ? (
        <Discount
          setSubmitLoading={setSubmitLoading}
          original={calculateTotalPrice()}
          currencyAr="ريال"
          currencyEn="sar"
          createOrder={createOrder}
          button={showButton}
          total={discTotal}
          discount={discAmount}
          setModal={setDiscountModal}
        />
      ) : null}
      {loading ? (
        <div style={{ height: "80vh" }} className="loader">
          <BeatLoader color={"#AA2A31"} loading={loading} size={30} />
        </div>
      ) : (
        <div>
          {errModal ? (
            <ErrorModal
              setModal={setErrModal}
              msg={i18n.language == "ar" ? arMsg : enMsg}
            />
          ) : null}
          {removeModal ? (
            <RemoveItem handleRemove={handleRemove} setModal={setRemoveModal} />
          ) : null}

          {clearModal ? (
            <CleartCart handleClear={handleClear} setModal={setClearModal} />
          ) : null}

          <div className="processNav">
            <Link to="/customer-orders" className="userData">
              <div>
                <img style={{ cursor: "pointer" }} src={icn1} />

                <p>{t("addOrder.profile")}</p>
              </div>
            </Link>

            <div className="dottedLine"></div>

            <Link to="/add-order" className="userData">
              <div>
                <img style={{ cursor: "pointer" }} src={icn2} alt="icon" />
                <p>{t("addOrder.details")}</p>
              </div>
            </Link>

            <div className="dottedLine"></div>
            <div>
              <img src={icn3} />
              <p>{t("addOrder.menu")}</p>
            </div>

            <div className="dottedLine"></div>
            <div>
              <img src={icn4} />
              <p style={{ color: "white" }}>{t("addOrder.send")}</p>
            </div>
          </div>
          <div
            style={
              i18n.language == "ar"
                ? { paddingRight: "1em", paddingLeft: "1.7em" }
                : { paddingRight: "1.7em", paddingLeft: "1em" }
            }
            className={
              toggleCart ? "container-fluid" : "container-fluid hiddenOf"
            }
          >
            <div className="navigateOrder">
              <a>{t("addOrder.search")}</a>
              {i18n.language == "ar" ? (
                <RiArrowLeftSFill />
              ) : (
                <RiArrowRightSFill />
              )}
              <Link
                to="/customer-orders"
                onClick={() => {
                  localStorage.removeItem("promoCode");
                  localStorage.setItem("discount", "false");
                }}
              >
                {t("addOrder.profile")} ({" "}
                {localStorage.getItem("customerPhone") +
                  " - " +
                  localStorage.getItem("customerName")}{" "}
                {localStorage.getItem("customerAwafi") !== "null"
                  ? `- ${t("addOrder.awafi")}`
                  : ""}{" "}
                ){" "}
              </Link>
              {i18n.language == "ar" ? (
                <RiArrowLeftSFill />
              ) : (
                <RiArrowRightSFill />
              )}
              <Link
                to="/add-order"
                onClick={() => {
                  localStorage.removeItem("promoCode");
                  localStorage.setItem("discount", "false");
                }}
              >
                {t("addOrder.details")}
              </Link>
              {i18n.language == "ar" ? (
                <RiArrowLeftSFill />
              ) : (
                <RiArrowRightSFill />
              )}
              {/*basket?
<a className='userData'>{t("addOrder.menu") + " "} ( {i18n.language=="ar"? basket.cart.branch.arName: basket.cart.branch.enName} )</a>
       :*/}
              <a className="userData">
                {t("addOrder.menu") + " "} ({" "}
                {i18n.language == "ar"
                  ? localStorage.getItem("branchNameAr")
                  : localStorage.getItem("branchNameEn")}{" "}
                )
              </a>
            </div>
            <div className="bgCon">
              <div className="row gy-1 menu">
                <div className="col-lg-2 col-md-3 col-sm-4 ">
                  <div
                    style={{
                      position: "sticky",
                      top: "20px",
                      width: "100%",
                      minWidth: "16vw",
                    }}
                  >
                    <div>
                      <p className="menuTitle">{t("menu.categories")}</p>
                    </div>
                    <div
                      // style={{ overflowX: "auto", maxHeight: "50vh" }}
                      className={
                        i18n.language == "ar"
                          ? "categories"
                          : "categories categoriesEn"
                      }
                    >
                      {menuCategories &&
                        menuCategories.map((data, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setCategoryId(data.id);
                              getProducts(data.id);
                              setMenuLoading(true);
                            }}
                            className={
                              touchsupport
                                ? data.id == categoryId
                                  ? "activeCategory"
                                  : null
                                : data.id == categoryId
                                  ? "non-touch activeCategory"
                                  : "non-touch"
                            }
                          >
                            <img
                              style={
                                i18n.language == "ar"
                                  ? { marginLeft: "0.5em" }
                                  : { marginRight: "0.5em" }
                              }
                              src={data.image}
                            />
                            <p>
                              {i18n.language == "ar"
                                ? data.arName
                                : data.enName}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-8 col-sm-7 col-11
  meals"
                >
                  <div className="menuSrch">
                    <p className="menuTitle">{t("menu.meals")}</p>

                    <div className="srchPos">
                      <input
                        value={searchTerm}
                        onChange={(e) => handleSearch(e)}
                        placeholder={t("dashboard.search")}
                      />
                      <AiOutlineSearch
                        className={
                          i18n.language == "ar"
                            ? "srchIcn"
                            : "srchIcn srchIcnEn"
                        }
                        size={30}
                      />
                    </div>
                  </div>
                  {menuLoading ? (
                    <div style={{ height: "60vh" }} className="loader">
                      <BeatLoader
                        color={"#AA2A31"}
                        loading={menuLoading}
                        size={30}
                      />
                    </div>
                  ) : (
                    <div
                      // style={{ overflowX: "auto", maxHeight: "50vh" }}
                      className="container-fluid"
                    >
                      <div className="row gy-4">
                        {productList &&
                          productList
                            .filter((data) => {
                              if (searchTerm === "") {
                                //for filtering products on search
                                return data;
                              } else if (
                                data.enName
                                  .toLowerCase()
                                  .includes(searchTerm.toLowerCase()) ||
                                data.arName
                                  .toLowerCase()
                                  .includes(searchTerm.toLowerCase())
                              ) {
                                return data;
                              }
                            })
                            .map((data, index) => (
                              <div

                                className="col-md-3 col-sm-4 col-6  mealDiv"
                                key={index}
                              >
                                <ImInfo

                                  title={
                                    i18n.language == "ar"
                                      ? data.arDescription
                                      : data.enDescription
                                  }
                                  className="info"
                                  size={30}
                                />
                                <p
                                  style={{ 'maxHeight': '26px', overflow: 'hidden' }}
                                  onClick={
                                    data.active == 1 || laterPeriod == true
                                      ? () => {

                                        getProduct(data.id);
                                        localStorage.setItem(
                                          "promoCode",
                                          codeRef.current.value
                                        );
                                      }
                                      : null
                                  }
                                  className="mealName"
                                >
                                  {" "}
                                  {i18n.language == "ar"
                                    ? data.arName
                                    : data.enName}{" "}
                                </p>
                                <div
                                  onClick={
                                    data.active == 1 || laterPeriod == true
                                      ? () => {



                                        getProduct(data.id);
                                        localStorage.setItem(
                                          "promoCode",
                                          codeRef.current.value
                                        );
                                      }
                                      : null
                                  }
                                  style={{
                                    backgroundImage: `url(${data.image})`,
                                  }}
                                ></div>
                                <p className="mealPrice">
                                  {data.price}{" "}
                                  {i18n.language == "ar"
                                    ? data.arCurrency
                                    : data.enCurrency}
                                </p>
                                <button
                                  disabled={
                                    data.active !== 1
                                  }
                                  onClick={() => {

                                    getProduct(data.id);
                                    localStorage.setItem(
                                      "promoCode",
                                      codeRef.current.value
                                    );
                                  }}
                                >
                                  {localStorage.getItem("type") ==
                                    "customerService"
                                    ? t("menu.addToCartForCust")
                                    : t("menu.addToCart")}{" "}
                                  <RiShoppingCartFill size={25} />
                                </button>
                              </div>
                            ))}
                      </div>
                    </div>
                  )}

                  {noProduct ? (
                    <div className="noProd">
                      <p>{t("menu.noProd")}</p>
                    </div>
                  ) : null}
                </div>

                {JSON.parse(localStorage.getItem("cartItems")) &&
                  JSON.parse(localStorage.getItem("cartItems")).length > 0 ? (
                  <div
                    className={
                      i18n.language == "ar"
                        ? "col-lg-4 col-1"
                        : "col-lg-4 col-1 carEn"
                    }
                  >
                    <div
                      className="cartActn"
                      onClick={() => setToggleCart(!toggleCart)}
                    >
                      <MdArrowForwardIos size={25} className="carArrow" />

                      <p className="crtTxt">{t("menu.cart")}</p>
                      <button className="cartBtn carIcn">
                        <RiShoppingCartFill size={25} />
                      </button>
                    </div>
                    <div
                      className={
                        toggleCart ? "cart cartOpen" : " cart cartClosed"
                      }
                    >
                      <button
                        className="cartBtn"
                        onClick={() => setToggleCart(!toggleCart)}
                      >
                        <IoClose size={30} />
                      </button>

                      <div className="toggleCart">
                        <div className="cartTop">
                          <p>{t("menu.cart")}</p>
                          <button onClick={() => setClearModal(true)}>
                            {t("menu.clear")}{" "}
                            <RiDeleteBin6Line style={{ color: "#e11857" }} />
                          </button>
                        </div>

                        {JSON.parse(localStorage.getItem("cartItems")) &&
                          JSON.parse(localStorage.getItem("cartItems")).map(
                            (data, index) => (
                              <div className="row cartItem" key={index}>
                                <div className="col-4">
                                  <div
                                    className="cartItem-Img"
                                    style={{
                                      backgroundImage: `url(${data.image})`,
                                    }}
                                  ></div>
                                </div>

                                <div className="col-8">
                                  <p className="cartItem-name">
                                    {i18n.language === "ar"
                                      ? data?.arName ?? ""
                                      : data?.enName ?? ""}
                                    -
                                    {i18n.language === "ar"
                                      ? data?.arDescription ?? ""
                                      : data?.enDescription ?? ""}
                                  </p>
                                  <button
                                    onClick={() => {
                                      setDelId(data.id);

                                      if (data.sized && data.sized.id) {
                                        setDelSizedId(data.sized.id);
                                      } else {
                                        setDelSizedId(null); 
                                      }
                                      if (
                                        data.selectedAddtionObj &&
                                        data.selectedAddtionObj.id
                                      ) {
                                        setDelAddId(data.selectedAddtionObj.id);
                                      } else {
                                        setDelAddId(null); 
                                      }

                                      setRemoveModal(true);
                                    }}
                                    className="cartItem-delete"
                                  >
                                    <RiDeleteBin6Line
                                      style={{ color: "#e11857" }}
                                    />
                                  </button>


                                  <div className="cartItem-quan">
                                    <button
                                      disabled={
                                        data.quantity >=
                                        data.avalilableQuantity && disableButton
                                      }
                                      onClick={() =>
                                        handleChangeQuantityOffline(
                                          data.id,
                                          data.sizeId,
                                          data.additionals[0],
                                          data.quantity + 1,
                                          data.quantity
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                    <div
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      {mealId == data.id ? (
                                        <div className="loader quantityLoader">
                                          <BeatLoader
                                            color={"#E47100"}
                                            loading={quanLoading}
                                            size={10}
                                          />
                                        </div>
                                      ) : null}

                                      <input
                                        type={"number"}
                                        id={data.id}
                                        className="quanBtn"
                                        value={data.quantity}
                                        onBlur={(e) =>
                                          handleChangeQuantityOffline(
                                            data.id,
                                            data.sizeId,
                                            data.additionals[0],
                                            e.target.value,
                                            data.quantity
                                          )
                                        }
                                      />
                                    </div>
                                    <button
                                      onClick={() =>
                                        data.quantity > 1
                                          ? handleChangeQuantityOffline(
                                            data.id,
                                            data.sizeId,
                                            data.additionals[0],
                                            data.quantity - 1,
                                            data.quantity
                                          )
                                          : null
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                  <p className="cartItem-price">
                                    <span style={{ fontWeight: "600" }}>
                                      {t("menu.price")}
                                    </span>{" "}
                                    {data.price * data.quantity }{" "}
                                    {i18n.language === "ar"
                                      ? parseInt(
                                        localStorage.getItem("branchId")
                                      ) === 32
                                        ? "دينار"
                                        : "ريال"
                                      : parseInt(
                                        localStorage.getItem("branchId")
                                      ) === 32
                                        ? "BHD"
                                        : "SAR"}
                                  </p>
                                </div>
                              </div>
                            )
                          )}

                        <hr></hr>
                        <p className="cartDivTitle">{t("menu.notes")}</p>

                        <div
                          id="list1"
                          className="dropdown-check-list"
                          tabIndex="100"
                        >
                          <div
                            style={
                              i18n.language == "ar"
                                ? { paddingLeft: "0.5em" }
                                : { paddingRight: "0.5em" }
                            }
                            className="srchNote"
                          >
                            <span onClick={dropDown} className="anchor">
                              {note == "" ? t("profile.choose") : note}
                            </span>
                          </div>

                          <ul className="items">
                            <li style={{ position: "relative" }}>
                              <input
                                type="text"
                                placeholder={t("dashboard.search")}
                                value={notesSearch}
                                onChange={(e) => handleSearchNotes(e)}
                              />
                              <AiOutlineSearch
                                className={
                                  i18n.language == "ar"
                                    ? "srchIcn"
                                    : "srchIcn srchIcnEn"
                                }
                                size={25}
                              />
                            </li>

                            {i18n.language == "ar" && static_notes
                              .filter((data) => {
                                if (notesSearch === "") {
                                  //for filtering products on search
                                  return data;
                                } else if (
                                  data
                                    .toLowerCase()
                                    .includes(notesSearch.toLowerCase())
                                ) {
                                  return data;
                                }
                              })
                              .map((data, index) => (
                                <li
                                  key={index}
                                  style={
                                    i18n.language == "ar"
                                      ? { direction: "ltr" }
                                      : null
                                  }
                                >
                                  <span> {data}</span>
                                  <input
                                    type="checkbox"
                                    className="checkNotes"
                                    value={data}
                                    onChange={(e) => handleNotes(e)}
                                  />
                                </li>
                              ))
                            }

                            <div dir="ltr" >
                              {i18n.language == "en" && static_notes_en
                                .filter((data) => {
                                  if (notesSearch === "") {
                                    //for filtering products on search
                                    return data;
                                  } else if (
                                    data
                                      .toLowerCase()
                                      .includes(notesSearch.toLowerCase())
                                  ) {
                                    return data;
                                  }
                                })
                                .map((data, index) => (
                                  <li
                                    key={index}
                                    style={
                                      i18n.language == "ar"
                                        ? { direction: "ltr" }
                                        : { direction: "rtl" }
                                    }
                                  >
                                    <span> {data}</span>
                                    <input
                                      type="checkbox"
                                      className="checkNotes"
                                      value={data}
                                      onChange={(e) => handleNotes(e)}
                                    />
                                  </li>
                                ))
                              }
                            </div>

                            {noNotes ? <li>{t("addOrder.noResult")}</li> : null}
                          </ul>
                        </div>

                        <textarea
                          name="notes"
                          className="noteText"
                          value={noteText}
                          onChange={(e) => {
                            setNoteText(e.target.value);
                            localStorage.setItem("notesOffline", e.target.value);
                            localStorage.setItem("notes", e.target.value);
                          }}
                        />


                        <hr></hr>

                        <p className="cartDivTitle">{t("menu.paymentMethod")}</p>
                        {paymentData && paymentData.paymentMethods.cash && (
                          <div className="paymentType">
                            <input
                              type="radio"
                              name="payment"
                              value="cash"
                              id="cash"
                              checked={selectedPayment === "cash"}
                              onChange={() => setSelectedPayment("cash")}
                            />
                            <label style={
                              i18n.language === "ar"
                                ? { marginRight: "0.5em" }
                                : { marginLeft: "0.5em" }
                            } htmlFor="cash">
                              {t("menu.cash")}
                            </label>
                          </div>
                        )}

                        {paymentData && paymentData.paymentMethods.wallet && parseFloat(paymentData.walletBalance) >= calculateTotalPrice() && (
                          <div className="paymentType">
                            <input
                              type="radio"
                              name="payment"
                              value="wallet"
                              id="wallet"
                              checked={selectedPayment === "wallet"}
                              onChange={(e) => {
                                setSelectedPayment(e.target.value);
                                localStorage.setItem("selectedPayment", e.target.value);
                                localStorage.removeItem("offer");
                                localStorage.setItem("PaymentMethodDisc", "wallet");
                              }}
                            />
                            <label
                              htmlFor="wallet"
                              style={
                                i18n.language === "ar"
                                  ? { marginRight: "0.5em" }
                                  : { marginLeft: "0.5em" }
                              }
                            >
                              {t("menu.wallet")}
                            </label>
                          </div>
                        )}



                        {paymentData && paymentData.paymentMethods.paymentOnline && (
                          <div className="paymentType">
                            <input
                              type="radio"
                              name="payment"
                              value="online"
                              id="online"
                              checked={selectedPayment === "online"}
                              onChange={(e) => {
                                setSelectedPayment(e.target.value);
                                localStorage.setItem("selectedPayment", e.target.value);
                                localStorage.removeItem("offer");
                                localStorage.setItem("PaymentMethodDisc", "online");
                              }}
                            />
                            <label
                              htmlFor="online"
                              style={
                                i18n.language === "ar"
                                  ? { marginRight: "0.5em" }
                                  : { marginLeft: "0.5em" }
                              }
                            >
                              {t("sendPaymentLink")}
                            </label>
                          </div>
                        )}

                        <hr></hr>

                        {localStorage.getItem("type") !== "cashier" ? (
                          <>
                            <p className="cartDivTitle">{t("menu.promoCode")}</p>
                            <div className="promoCode">
                              <div style={{ position: "relative" }}>
                                <input
                                  style={!discount ? { width: "92%" } : null}
                                  ref={codeRef}
                                  value={codeValue}
                                  onChange={(e) => {
                                    setCodeValue(e.target.value);
                                    localStorage.setItem(
                                      "promoCode",
                                      e.target.value
                                    );
                                  }}
                                  className={codeInvalid ? "invalid" : null}
                                />
                                {(discount || freeMealsDisc || cashBackDisc) &&
                                  !(codeValue == null) &&
                                  !(codeValue == "") ? (
                                  <>
                                    <button
                                      onClick={handleDelPromo}
                                      className={
                                        i18n.language == "delPromo delPromoEn"
                                          ? ""
                                          : "delPromo"
                                      }
                                    >
                                      x
                                    </button>

                                    <TiTick className="tick" size={28} />
                                  </>
                                ) : null}
                              </div>

                              <button
                                onClick={() => {
                                  handleOffer(false);
                                }}
                              >
                                {t("menu.confirm")}
                              </button>
                            </div>
                            {errModal2 &&
                              !(codeValue == null) &&
                              !(codeValue == "") ? (
                              <span className="err">
                                {i18n.language == "ar" ? arMsg : enMsg}
                              </span>
                            ) : null}

                            <hr></hr>
                          </>
                        ) : null}
                        {/* check if order type == 5 */}


                        <div className="cartBreakdown">
                          <p>{t("menu.total")}</p>
                          <p style={{ fontWeight: "300" }}>
                            {paymentData && paymentData.originalPrice}{" "}
                            {i18n.language === "ar"
                              ? parseInt(localStorage.getItem("branchId")) === 32
                                ? "دينار"
                                : "ريال"
                              : parseInt(localStorage.getItem("branchId")) === 32
                                ? "BHD"
                                : "SAR"}
                          </p>
                        </div>

                        <div className="cartBreakdown">
                          <p>
                            {t("singleOrder.tax")}
                            {` (${parseInt(localStorage.getItem("branchId")) === 32
                              ? 5
                              : 15
                              }% )`}
                          </p>
                          <p style={{ fontWeight: "300" }}>
                            {paymentData && paymentData.taxValue.toFixed(2)}{" "}
                            {i18n.language === "ar"
                              ? parseInt(localStorage.getItem("branchId")) === 32
                                ? "دينار"
                                : "ريال"
                              : parseInt(localStorage.getItem("branchId")) === 32
                                ? "BHD"
                                : "SAR"}
                          </p>
                        </div>


                        {discAmount && (
                          <div
                            style={{ backgroundColor: "rgb(225, 24, 87)" }}
                            className="cartBreakdown"
                          >
                            <p>{t("menu.disc")}</p>

                            <p>
                              {discAmount +
                                parseFloat(
                                  localStorage.getItem("selectedPriceTable") || 0
                                )}{" "}
                              {i18n.language === "ar"
                                ? parseInt(localStorage.getItem("branchId")) === 32
                                  ? "دينار"
                                  : "ريال"
                                : parseInt(localStorage.getItem("branchId")) === 32
                                  ? "BHD"
                                  : "SAR"}
                            </p>
                          </div>
                        )}

                        {paymentData && paymentData.deliveryPrice !== 0 && (
                          <div
                            style={{ backgroundColor: "rgb(225, 24, 87)" }}
                            className="cartBreakdown"
                          >


                            <p> {i18n.language == "ar" ? 'سعر التوصيل' : 'Delivery Price '} </p>

                            <p>
                              {paymentData && parseFloat(paymentData.deliveryPrice)}

                              {i18n.language === "ar"
                                ? parseInt(localStorage.getItem("branchId")) === 32
                                  ? "دينار"
                                  : "ريال"
                                : parseInt(localStorage.getItem("branchId")) === 32
                                  ? "BHD"
                                  : "SAR"}
                            </p>
                          </div>
                        )}



                        <div
                          style={{ backgroundColor: "rgb(225, 24, 87)" }}
                          className="cartBreakdown"
                        >
                          <p>{t("menu.Total")}</p>

                          <p>
                            {paymentData && (parseFloat(paymentData.totalPrice) - parseFloat(discAmount || 0))} {" "}

                            {i18n.language === "ar"
                              ? parseInt(localStorage.getItem("branchId")) === 32
                                ? "دينار"
                                : "ريال"
                              : parseInt(localStorage.getItem("branchId")) === 32
                                ? "BHD"
                                : "SAR"}
                          </p>
                        </div>

                        {submitLoading ? (
                          <div
                            style={{ height: "5vh", marginTop: "1em" }}
                            className="loader"
                          >
                            <BeatLoader
                              color={"#E47100"}
                              loading={submitLoading}
                              size={20}
                            />
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              if (navigator.onLine) {
                                localStorage.getItem("offer")
                                  ? createOrder()
                                  : handleOffer(true);
                              } else {
                                createOrder();
                              }
                            }}
                            className="sendOrder"
                          >
                            {t("menu.send")}
                          </button>
                        )}

                        <hr></hr>

                        <div className="cartTop">
                          <p>{t("addOrder.details")}</p>
                        </div>

                        <div className="cstmrDetails">
                          <p>
                            <span>{t("profile.cstmrName")} : </span>
                            {localStorage.getItem("customerName") ?? localStorage.getItem("userName")}
                          </p>

                          {/* <p>
                          <span>{t("singleOrder.order_time")} : </span>{" "}
                          {localStorage.getItem("type") == "cashier"
                            ? t("addOrder.now")
                            : localStorage.getItem("now") == "true"
                            ? t("addOrder.now")
                            : `${t("addOrder.later")}  ${localStorage.getItem(
                                "orderDate"
                              )} ${localStorage.getItem("orderTime")}`}
                        </p> */}

                          <p>
                            <span>{t("orders.orderType")} : </span>
                            {localStorage.getItem("orderType") == 1
                              ? t("addOrder.branch")
                              : localStorage.getItem("orderType") == 5
                                ? t("menu.tables")
                                : t("menu.home")}
                          </p>
                          {localStorage.getItem("orderType") == 5 ? (
                            <p>
                              <span>{t("tables.tableNum")} : </span>
                              {localStorage.getItem("selectedTable") == 0
                                ? t("menu.waiting")
                                : localStorage.getItem("selectedTable")}
                            </p>
                          ) : null}



                          {orderSourceObj && (
                            <p>
                              <span>{t("orders.source")} : </span>
                              {orderSourceObj.name}
                            </p>
                          )}

                          {orderSource !== 5 && externalOrderId && (
                            <p>
                              <span>{t("menu.external")} </span>
                              {externalOrderId}
                            </p>
                          )}

                          <p>
                            <span>{t('addOrder.time')}</span> {" : "}
                            <span>{i18n.language == "ar" ? 'الان' : 'now'}</span>

                          </p>
                          <p>
                            <span>{t('externalSales.byPhone')}</span> {" : "}
                            <span>{localStorage.getItem("customerPhone")}</span>

                          </p>
                          <p>
                            <span>{t('addOrder.time')}</span> {" : "}
                            <span>{i18n.language == "ar" ? 'الان' : 'now'}</span>

                          </p>
                          {localStorage.getItem("orderType") == 2 && (
                            <p>
                              <span>
                                {i18n.language == "ar" ? 'الحد الادني للطلب' : 'Minimum Order Price '} {' :'}  {paymentData && paymentData.areaData && paymentData.areaData.minOrder} {t('profile.sar')}
                              </span>

                            </p>
                          )}
                          {localStorage.getItem("orderType") == 2 && (
                            <p>
                              <span>
                                {i18n.language == "ar" ? 'سعر التوصيل' : 'Delivery Price '} {' :'}  {paymentData && parseFloat(paymentData.deliveryPrice)} {t('profile.sar')}
                              </span>

                            </p>
                          )}

                          {localStorage.getItem("orderType") == 2 ? (
                            <p>
                              <span>{t("menu.address")} : </span>
                              {i18n.language == "ar"
                                ? localStorage.getItem("arAddress")
                                : localStorage.getItem("enAddress")}
                              <br />
                              {i18n.language == "ar"
                                ? t("profile.branch") +
                                ": " +
                                localStorage.getItem("branchNameAr")
                                : t("profile.branch") +
                                ": " +
                                localStorage.getItem("branchNameEn")}
                            </p>
                          ) : (
                            <>
                              <p>
                                <span>{t("profile.branch")} : </span>
                                {i18n.language == "ar"
                                  ? localStorage.getItem("branchNameAr")
                                  : localStorage.getItem("branchNameEn")}
                              </p>
                              {/* <p>
                              <span>{t("addOrder.pickup")} : </span>{" "}
                              {localStorage.getItem("branchOrderTime")}{" "}
                              {t("addOrder.minutes")}
                            </p> */}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
    </div>
  );
}

export default Menu;
